import { useEffect } from "react";

/**
 * Lock body scroll while a modal is mounted.
 * Prevents iOS Safari from scrolling the page behind fixed overlays,
 * which causes horizontal offset bugs on close.
 */
export function useScrollLock() {
  useEffect(() => {
    const scrollY = window.scrollY;
    const { overflow, position, top, width } = document.body.style;

    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = overflow;
      document.body.style.position = position;
      document.body.style.top = top;
      document.body.style.width = width;
      window.scrollTo(0, scrollY);
    };
  }, []);
}
